var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',_vm._b({class:{ 'text-btn': _vm.type === 'text' },on:{"click":_vm.handleClick}},'el-button',_vm.props,false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }